var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Archives',{attrs:{"studio":_vm.studio,"broadcasts":_vm.broadcasts,"shows":_vm.shows,"toolbar-enabled":_vm.enableArchivesToolbar},on:{"show-select":_vm.filterShowsById,"date-select":_vm.filterDate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }